/* eslint-disable jsx-a11y/anchor-is-valid */
import useFetch from 'use-http';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Page from '../../../../../shared/Page';
import Styled from '../../UserAccountPage.styles';
import Loader from '../../../../../shared/Loader';
import LegacyButton from '../../../../../shared/Button/Button';
import { AiOutlineEdit } from 'react-icons/ai';
import ServiceEditDialog from './ServiceEditDialog';

const INITIAL_PAGE_SIZE = 50;
const LOAD_MORE_STEP = 10;

const ServiceInformation = () => {
  const [loading, setLoading] = useState(true);
  const [fullData, setFullData] = useState([]);
  const [reload, setReload] = useState(false);
  const [visibleCount, setVisibleCount] = useState(INITIAL_PAGE_SIZE);
  const [selectedService, setSelectedService] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { get: getServicesDescription } = useFetch('/ServicesDescription');
  const updateReload = useRef(false);

  const filteredData = useMemo(() => {
    if (!search?.trim()) {
      return fullData;
    }

    const searchValue = search.toLowerCase().trim();

    return fullData.filter((item) =>
      item.title?.toLowerCase().includes(searchValue),
    );
  }, [fullData, search]);

  const visibleServices = useMemo(
    () => filteredData.slice(0, visibleCount),
    [filteredData, visibleCount],
  );

  const changeReload = () => {
    updateReload.current = true;
    setReload((prev) => !prev);
    setLoading(true);
  };

  useEffect(() => {
    setReload((prev) => !prev);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const res = await getServicesDescription();

      const sortedRes = [...(res ?? [])].sort((a, b) =>
        (a.title || '').localeCompare(b.title || ''),
      );

      setFullData(sortedRes);

      if (!updateReload.current) {
        setVisibleCount(INITIAL_PAGE_SIZE);
      }

      updateReload.current = false;
      setLoading(false);
    };

    fetchData();
  }, [reload, getServicesDescription]);

  useEffect(() => {
    setVisibleCount(INITIAL_PAGE_SIZE);
  }, [search]);

  const clearSearchField = () => {
    setSearch('');
  };

  const handleEditOpen = (service) => {
    setSelectedService(service);
    setEditDialogOpen(true);
  };

  const handleDialogClose = (open) => {
    setEditDialogOpen(open);

    if (!open) {
      setSelectedService(null);
    }
  };

  return (
    <Page>
      <Styled.DataContainer>
        <Styled.TabTitleWrapper>
          <Styled.TabTitle>Paslaugų informacija</Styled.TabTitle>

          <form
            autoComplete="off"
            onSubmit={(e) => e.preventDefault()}
            className="flex items-center gap-3"
          >
            <input
              type="text"
              id="search"
              placeholder="Paieška"
              name="search"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              className="h-10 min-w-[240px] rounded-md border border-gray-300 px-3 outline-none focus:border-gray-500"
            />

            <LegacyButton size="small" type="button" onClick={clearSearchField}>
              Išvalyti
            </LegacyButton>
          </form>
        </Styled.TabTitleWrapper>

        {loading && (
          <Page>
            <Loader />
          </Page>
        )}

        {!loading &&
          visibleServices.map((sp, index) => (
            <div key={sp.serviceExternalId ?? index}>
              <Styled.Visit>
                <Styled.DoctorInfoListRecord>
                  <div className="flex w-full min-w-0 items-start gap-3">
                    <AiOutlineEdit
                      onClick={() => handleEditOpen(sp)}
                      className="shrink-0 cursor-pointer"
                    />

                    <div className="flex min-w-0 w-full flex-col">
                      <Styled.DoctorName>
                        {sp.title?.toString().toUpperCase()}
                      </Styled.DoctorName>

                      <Styled.DescriptionUrl>
                        {sp.descriptionUrl}
                      </Styled.DescriptionUrl>
                    </div>
                  </div>
                </Styled.DoctorInfoListRecord>
              </Styled.Visit>
            </div>
          ))}

        {!loading && filteredData.length > visibleCount && (
          <Styled.LoadMoreBtn>
            <LegacyButton
              onClick={() => setVisibleCount((prev) => prev + LOAD_MORE_STEP)}
            >
              Rodyti daugiau
            </LegacyButton>
          </Styled.LoadMoreBtn>
        )}
      </Styled.DataContainer>

      <ServiceEditDialog
        open={editDialogOpen}
        onOpenChange={handleDialogClose}
        service={selectedService}
        changeReload={changeReload}
      />
    </Page>
  );
};

export default ServiceInformation;
